import React, {
  useEffect
} from 'react';

import {
  Drawer
} from 'antd';
import {
  DrawerProps
} from 'antd/lib/drawer';

import {
  useTranslation
} from 'react-i18next';

import {
  useMap
} from '@terrestris/react-geo/dist/Hook/useMap';

import './index.less';

export const SideDrawer: React.FC<Partial<DrawerProps>> = ({
  open,
  ...passThroughProps
}): JSX.Element => {

  const {
    t
  } = useTranslation();

  const map = useMap();

  useEffect(() => {
    const action = () => {
      if (open) {
        document.querySelectorAll('.map-component')[0]?.classList.add('bisected');
      } else {
        document.querySelectorAll('.map-component')[0]?.classList.remove('bisected');
      }
    };
    const timeoutId = setTimeout(action, 1);
    return () => clearTimeout(timeoutId);
  }, [open]);

  const onAfterDrawerOpenChange = () => {
    map?.updateSize();
  };

  return (
    <Drawer
      className="side-drawer"
      title={t('Drawer.title')}
      placement="right"
      open={open}
      mask={false}
      width={'40vw'}
      afterOpenChange={onAfterDrawerOpenChange}
      {...passThroughProps}
    />
  );
};

export default SideDrawer;
